export type MediaType = "movie" | "tv";

export interface Episode {
  episode: number;
  title: string;
  desc: string;
}

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  cover: string;
  backdrop?: string;
  year: number;
  region: string;
  director: string;
  cast: string[];
  genres: string[];
  tags: string[];
  summary: string;
  subtitleInfo: string;
  views: number;
  updatedAt: string;
  rating: number;
  featured?: boolean;
  episodes?: Episode[];
}

export const GENRES: string[] = [
  "动作",
  "剧情",
  "喜剧",
  "科幻",
  "悬疑",
  "爱情",
  "犯罪",
  "奇幻",
  "冒险",
  "历史",
  "战争",
  "家庭",
];

export interface YearRange {
  label: string;
  min: number;
  max: number;
}

export const YEAR_RANGES: YearRange[] = [
  { label: "近5年", min: 2021, max: 2025 },
  { label: "2019-2020", min: 2019, max: 2020 },
  { label: "2015-2018", min: 2015, max: 2018 },
];

export const movies: MediaItem[] = [
  {
    id: "m01",
    title: "星海彼岸",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20lone%20astronaut%20standing%20before%20a%20vast%20glowing%20ocean%20of%20stars%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20a%20lone%20astronaut%20standing%20before%20a%20vast%20glowing%20ocean%20of%20stars%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=1600&height=900&seq=hero-m01&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    director: "陈屿",
    cast: ["林越", "苏皖", "程亦航"],
    genres: ["科幻", "冒险", "剧情"],
    tags: ["太空", "中文特效字幕", "杜比视界"],
    summary:
      "一场跨越星海的孤独航行，让失联多年的宇航员重新面对地球与家人的记忆。宏大视效与细腻情感交织，是今年最受期待的中文字幕科幻片之一。",
    subtitleInfo:
      "官方蓝光中文字幕已上线，包含简体与繁体双语轨道，时间轴已校对至影院公映版本。",
    views: 286400,
    updatedAt: "2025-10-12",
    rating: 8.6,
    featured: true,
  },
  {
    id: "m02",
    title: "长夜将尽",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20rain-soaked%20deserted%20city%20street%20at%20midnight%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m02&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    director: "周叙白",
    cast: ["段清和", "黎晚", "顾南舟"],
    genres: ["悬疑", "犯罪", "剧情"],
    tags: ["连环案件", "中文字幕", "高分悬疑"],
    summary:
      "一名刑警在漫漫长夜里追查一桩尘封旧案，真相随着雨夜逐渐浮出水面。节奏冷峻，反转不断。",
    subtitleInfo: "中文字幕已更新至终剪版本，附案件时间线说明字幕注释。",
    views: 214300,
    updatedAt: "2025-10-08",
    rating: 8.1,
  },
  {
    id: "m03",
    title: "山河故梦",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20an%20old%20mountain%20village%20under%20golden%20dusk%20light%20with%20a%20flowing%20river%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m03&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    director: "沈知远",
    cast: ["何靖", "宋清扬", "秦苏"],
    genres: ["剧情", "历史"],
    tags: ["年代", "家国", "中文字幕"],
    summary:
      "三代人跨越半个世纪的家族史诗，在山河与时代的变迁中寻找归途。画面诗意，情感厚重。",
    subtitleInfo: "中文字幕已上线，含方言对白字幕翻译注释，方便理解地方语境。",
    views: 176500,
    updatedAt: "2025-09-26",
    rating: 8.4,
  },
  {
    id: "m04",
    title: "追风少年",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20teenage%20runner%20sprinting%20on%20a%20dusty%20countryside%20track%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m04&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    director: "许南风",
    cast: ["韦一鸣", "江予", "郑好"],
    genres: ["剧情", "运动", "家庭"],
    tags: ["励志", "热血", "中文字幕"],
    summary:
      "小镇少年为了梦想踏上田径场，用一双跑鞋丈量与世界的距离。热血又温柔。",
    subtitleInfo: "中文字幕已更新，比赛解说部分提供额外中文译注字幕。",
    views: 132800,
    updatedAt: "2025-09-18",
    rating: 7.9,
  },
  {
    id: "m05",
    title: "城市之光",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20neon%20reflections%20on%20a%20lonely%20downtown%20avenue%20at%20night%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20neon%20reflections%20on%20a%20lonely%20downtown%20avenue%20at%20night%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=1600&height=900&seq=hero-m05&orientation=landscape",
    year: 2025,
    region: "中国香港",
    director: "麦嘉伦",
    cast: ["谭子谦", "李映彤", "何家俊"],
    genres: ["犯罪", "剧情", "动作"],
    tags: ["警匪", "港片", "中文字幕"],
    summary:
      "一场发生在不夜城的警匪博弈，光与影之间没有绝对的正义。风格凌厉，张力十足。",
    subtitleInfo: "粤语原声配中文简体字幕已上线，含港式俚语译注。",
    views: 198700,
    updatedAt: "2025-10-10",
    rating: 8.0,
    featured: true,
  },
  {
    id: "m06",
    title: "雾都疑云",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20foggy%20victorian-era%20city%20alley%20with%20a%20distant%20silhouette%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m06&orientation=portrait",
    year: 2023,
    region: "英国",
    director: "Adam Cole",
    cast: ["Edmund Hale", "Rose Whitfield", "Nina Marsh"],
    genres: ["悬疑", "犯罪", "剧情"],
    tags: ["英伦", "侦探", "中文字幕"],
    summary:
      "维多利亚时代的浓雾中，一桩离奇失踪案牵出整座城市的秘密。氛围阴郁，推理缜密。",
    subtitleInfo: "英文字幕对照中文翻译已上线，专有名词按官方译名统一。",
    views: 121400,
    updatedAt: "2025-09-05",
    rating: 7.8,
  },
  {
    id: "m07",
    title: "时间褶皱",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20abstract%20fractured%20clockwork%20folds%20of%20light%20and%20shadow%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m07&orientation=portrait",
    year: 2024,
    region: "美国",
    director: "Miles Verne",
    cast: ["Evan Stone", "Clara Reed", "Owen Park"],
    genres: ["科幻", "悬疑", "剧情"],
    tags: ["时间循环", "硬科幻", "中文字幕"],
    summary:
      "物理学家发现时间的褶皱后，一次次回到同一天试图改变结局。烧脑设定，逻辑自洽。",
    subtitleInfo: "中文字幕已上线，科学术语部分提供双语对照字幕。",
    views: 165900,
    updatedAt: "2025-09-22",
    rating: 8.3,
  },
  {
    id: "m08",
    title: "雨季不再来",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20woman%20holding%20an%20umbrella%20on%20a%20quiet%20rainy%20street%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m08&orientation=portrait",
    year: 2023,
    region: "中国台湾",
    director: "林书妍",
    cast: ["陈以晴", "吴柏翰", "许安宁"],
    genres: ["爱情", "剧情"],
    tags: ["文艺", "青春", "中文字幕"],
    summary:
      "一场雨季里的相遇与告别，关于成长也关于错过。细腻温柔，后劲十足。",
    subtitleInfo: "中文字幕已上线，配闽南语对白中文译注。",
    views: 98700,
    updatedAt: "2025-08-29",
    rating: 7.6,
  },
  {
    id: "m09",
    title: "荒野归途",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20hiker%20facing%20a%20wide%20desolate%20wilderness%20at%20sunrise%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m09&orientation=portrait",
    year: 2022,
    region: "澳大利亚",
    director: "Hannah Boyd",
    cast: ["Liam Ford", "Grace Doyle", "Noah Price"],
    genres: ["冒险", "剧情", "家庭"],
    tags: ["荒野求生", "治愈", "中文字幕"],
    summary:
      "父亲带着女儿穿越荒野寻找回家的路，在绝境中重新读懂彼此。风景壮阔，情感真挚。",
    subtitleInfo: "中文字幕已更新，环境音与画外音说明以注释形式呈现。",
    views: 74600,
    updatedAt: "2025-08-15",
    rating: 7.7,
  },
  {
    id: "m10",
    title: "暗涌",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20dark%20rippling%20water%20under%20a%20single%20cold%20spotlight%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m10&orientation=portrait",
    year: 2024,
    region: "韩国",
    director: "박준서",
    cast: ["김도현", "이서연", "최민재"],
    genres: ["犯罪", "惊悚", "剧情"],
    tags: ["暗黑", "复仇", "中文字幕"],
    summary:
      "平静水面的暗流之下，一场精心策划的复仇正在展开。冷峻克制，压迫感十足。",
    subtitleInfo: "韩语原声配中文简体字幕已上线，含人物关系提示字幕。",
    views: 142100,
    updatedAt: "2025-09-12",
    rating: 8.2,
  },
  {
    id: "m11",
    title: "人间烟火",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20warm%20family%20kitchen%20table%20with%20soft%20evening%20lamplight%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m11&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    director: "罗一舟",
    cast: ["孙桂英", "赵建国", "钱多多"],
    genres: ["剧情", "家庭", "喜剧"],
    tags: ["市井", "治愈", "中文字幕"],
    summary:
      "一条老街，一间小馆，几户人家的柴米油盐与悲欢离合。真实动人，笑中带泪。",
    subtitleInfo: "中文字幕已上线，含菜名与方言小吃的译注说明。",
    views: 88500,
    updatedAt: "2025-08-22",
    rating: 8.0,
  },
  {
    id: "m12",
    title: "极夜行动",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20soldiers%20marching%20through%20deep%20snow%20under%20a%20dark%20polar%20sky%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-m12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20soldiers%20marching%20through%20deep%20snow%20under%20a%20dark%20polar%20sky%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=1600&height=900&seq=hero-m12&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    director: "雷振霆",
    cast: ["方烈", "石峰", "温若"],
    genres: ["动作", "战争", "剧情"],
    tags: ["军事", "大场面", "中文字幕"],
    summary:
      "极夜之下，一支小队执行着几乎不可能完成的任务。紧张刺激，燃点与泪点并存。",
    subtitleInfo: "中文字幕已上线，军事术语配中文译注字幕条。",
    views: 231600,
    updatedAt: "2025-10-05",
    rating: 8.5,
    featured: true,
  },
  {
    id: "t01",
    title: "长安谜案",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20an%20ancient%20Chinese%20courtyard%20at%20night%20lit%20by%20red%20lanterns%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20an%20ancient%20Chinese%20courtyard%20at%20night%20lit%20by%20red%20lanterns%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=1600&height=900&seq=hero-t01&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    director: "陆怀安",
    cast: ["裴照", "柳青禾", "顾长风"],
    genres: ["悬疑", "历史", "剧情"],
    tags: ["古装", "探案", "中文字幕"],
    summary:
      "盛唐长安，一桩桩离奇命案背后藏着更大的阴谋。服化道考究，探案节奏紧凑。",
    subtitleInfo: "全剧中文字幕已更新至第 6 集，古文台词配白话译注。",
    views: 342800,
    updatedAt: "2025-10-09",
    rating: 8.7,
    featured: true,
    episodes: [
      { episode: 1, title: "灯下无影", desc: "上元灯会之夜，一具无名尸体出现在曲江池畔。" },
      { episode: 2, title: "铜镜迷局", desc: "一面古镜牵扯出三年前的旧案，线索直指东市。" },
      { episode: 3, title: "西市疑云", desc: "商队失踪案与命案交汇，凶手身份初现端倪。" },
      { episode: 4, title: "玉簪之谜", desc: "一支玉簪让嫌疑人浮出水面，却另有隐情。" },
      { episode: 5, title: "雨夜追凶", desc: "暴雨封城之夜，真凶在暗处步步紧逼。" },
      { episode: 6, title: "长安黎明", desc: "真相揭开，长安城迎来第一缕晨光。" },
    ],
  },
  {
    id: "t02",
    title: "苍穹之下",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20futuristic%20sky%20city%20floating%20above%20clouds%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20backdrop%2C%20a%20futuristic%20sky%20city%20floating%20above%20clouds%2C%20epic%20atmospheric%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20subtle%20film%20grain%2C%20minimal%20clean%20composition%20with%20space%20for%20text%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20moody%2C%20consistent%20series%20style&width=1600&height=900&seq=hero-t02&orientation=landscape",
    year: 2025,
    region: "中国大陆",
    director: "苏子墨",
    cast: ["沈岸", "白露", "季昀"],
    genres: ["科幻", "剧情", "悬疑"],
    tags: ["未来", "反乌托邦", "中文字幕"],
    summary:
      "浮空城与地表废土的双城故事，一群年轻人试图揭开苍穹之下的真相。设定宏大，悬念迭起。",
    subtitleInfo: "中文字幕已更新至第 6 集，含专有名词中英对照表。",
    views: 289400,
    updatedAt: "2025-10-06",
    rating: 8.5,
    episodes: [
      { episode: 1, title: "上升之城", desc: "少年意外获得登上浮空城的资格。" },
      { episode: 2, title: "云上秩序", desc: "光鲜的浮空城背后隐藏着严格的等级规则。" },
      { episode: 3, title: "废土来客", desc: "一名地表幸存者带来了被隐瞒的消息。" },
      { episode: 4, title: "记忆迷雾", desc: "主角发现自己的身份记忆被动过手脚。" },
      { episode: 5, title: "断裂的天空", desc: "一次意外的坠落揭开双城的真正联系。" },
      { episode: 6, title: "苍穹回响", desc: "真相的第一块拼图浮出水面。" },
    ],
  },
  {
    id: "t03",
    title: "海岸线",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20calm%20coastline%20with%20modern%20glass%20villas%20at%20dusk%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t03&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    director: "温以宁",
    cast: ["许知夏", "傅斯年", "林澄"],
    genres: ["都市", "爱情", "剧情"],
    tags: ["治愈", "海岸", "中文字幕"],
    summary:
      "沿海小城的一群年轻人，在事业与情感之间寻找自己的海岸线。轻松治愈，画面养眼。",
    subtitleInfo: "中文字幕已更新至第 6 集，配海岛方言译注。",
    views: 156200,
    updatedAt: "2025-09-14",
    rating: 7.8,
    episodes: [
      { episode: 1, title: "回到海边", desc: "女主辞职回到故乡接手一间老民宿。" },
      { episode: 2, title: "潮汐来信", desc: "一封没有署名的信打乱了平静的生活。" },
      { episode: 3, title: "旧友重逢", desc: "高中时的伙伴们重新聚集在海边。" },
      { episode: 4, title: "台风过境", desc: "一场台风让所有人的关系发生改变。" },
      { episode: 5, title: "灯塔之夜", desc: "在灯塔下的长谈解开了多年的心结。" },
      { episode: 6, title: "面朝大海", desc: "每个人都在海岸线上找到答案。" },
    ],
  },
  {
    id: "t04",
    title: "白鹿秘境",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20mystical%20white%20deer%20in%20an%20enchanted%20misty%20forest%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t04&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    director: "云清辞",
    cast: ["叶星阑", "洛昭", "慕白"],
    genres: ["奇幻", "冒险", "剧情"],
    tags: ["东方奇幻", "秘境", "中文字幕"],
    summary:
      "进入白鹿守护的秘境，少年少女们开始了一场关于勇气与约定的冒险。奇幻瑰丽，想象天马行空。",
    subtitleInfo: "中文字幕已更新至第 6 集，含设定名词译注。",
    views: 174600,
    updatedAt: "2025-09-08",
    rating: 8.1,
    episodes: [
      { episode: 1, title: "雾林初启", desc: "少年误入传说中的白鹿秘境。" },
      { episode: 2, title: "守林之人", desc: "神秘守林人向少年道出秘境的规则。" },
      { episode: 3, title: "流光之森", desc: "为寻找失散的同伴穿越发光森林。" },
      { episode: 4, title: "鹿角之约", desc: "白鹿现身，许下一个古老的约定。" },
      { episode: 5, title: "暗影追踪", desc: "秘境中出现觊觎灵力的侵入者。" },
      { episode: 6, title: "秘境之心", desc: "少年们守护住秘境的核心秘密。" },
    ],
  },
  {
    id: "t05",
    title: "心术医师",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20hospital%20corridor%20glowing%20with%20cool%20surgical%20light%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t05&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    director: "顾行知",
    cast: ["程知微", "江衍", "苏牧"],
    genres: ["医疗", "剧情"],
    tags: ["行业剧", "仁心", "中文字幕"],
    summary:
      "一群心外科医生在高强度的手术台前守护生命的故事。专业写实，情感真挚。",
    subtitleInfo: "中文字幕已更新至第 6 集，医学名词配中文译注。",
    views: 118900,
    updatedAt: "2025-08-26",
    rating: 7.9,
    episodes: [
      { episode: 1, title: "第一台手术", desc: "新人医生迎来职业生涯的第一场大手术。" },
      { episode: 2, title: "深夜急诊", desc: "深夜急诊室里的一场生死营救。" },
      { episode: 3, title: "两难抉择", desc: "面对罕见的病例，医生们做出艰难决定。" },
      { episode: 4, title: "信任之重", desc: "一位老病人让主角重新理解「医者仁心」的分量。" },
      { episode: 5, title: "手术台上", desc: "突发状况考验着整个医疗团队。" },
      { episode: 6, title: "心跳之声", desc: "在监护仪的滴答声中迎来新的希望。" },
    ],
  },
  {
    id: "t06",
    title: "烽火征程",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20war-torn%20historic%20battlefield%20under%20smoke%20and%20dusk%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t06&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    director: "岳峥",
    cast: ["何炽", "方晴", "叶准"],
    genres: ["战争", "历史", "剧情"],
    tags: ["史诗", "群像", "中文字幕"],
    summary:
      "一段关于信念与牺牲的烽火岁月，普通人在大时代中的选择与坚守。厚重而克制。",
    subtitleInfo: "中文字幕已更新至第 6 集，含历史背景字幕注释。",
    views: 107300,
    updatedAt: "2025-08-18",
    rating: 8.2,
    episodes: [
      { episode: 1, title: "出征", desc: "小人物被时代推上前线。" },
      { episode: 2, title: "坚守", desc: "在孤立无援中守住阵地的信念。" },
      { episode: 3, title: "归途", desc: "一次突围让人重新理解回家的含义。" },
      { episode: 4, title: "家书", desc: "一封家书串联起前后方的牵挂。" },
      { episode: 5, title: "黎明前夜", desc: "最艰难的一夜，也是最接近胜利的一夜。" },
      { episode: 6, title: "山河无恙", desc: "硝烟散去，山河终于迎来安宁。" },
    ],
  },
  {
    id: "t07",
    title: "无声证词",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20forensic%20analyst%20examining%20a%20case%20file%20in%20a%20dim%20office%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t07&orientation=portrait",
    year: 2025,
    region: "中国大陆",
    director: "纪川",
    cast: ["闻枭", "韩雪晴", "陆行舟"],
    genres: ["悬疑", "犯罪", "剧情"],
    tags: ["刑侦", "法医", "中文字幕"],
    summary:
      "法医与刑警联手，用沉默的证据还原被掩盖的真相。逻辑严密，案件环环相扣。",
    subtitleInfo: "中文字幕已更新至第 6 集，法医术语配中文译注。",
    views: 248500,
    updatedAt: "2025-10-11",
    rating: 8.6,
    episodes: [
      { episode: 1, title: "沉默的现场", desc: "一具无名尸体带来第一道难解谜题。" },
      { episode: 2, title: "微观证物", desc: "一丝纤维成为锁定嫌疑人的关键。" },
      { episode: 3, title: "时间证人", desc: "通过尸体状态推断出被篡改的时间线。" },
      { episode: 4, title: "第二现场", desc: "真凶留下的第二现场反而暴露了破绽。" },
      { episode: 5, title: "记忆碎片", desc: "案件与多年前的旧案产生意想不到的交集。" },
      { episode: 6, title: "证词终结", desc: "所有证据汇成一句无声却有力的证词。" },
    ],
  },
  {
    id: "t08",
    title: "银河列车",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20film%20poster%20key%20art%2C%20a%20retro-futuristic%20train%20speeding%20through%20a%20starry%20galaxy%2C%20dramatic%20low-key%20lighting%20with%20deep%20navy%20blue%20and%20warm%20amber%20contrast%2C%20subtle%20film%20grain%20texture%2C%20minimal%20dark%20gradient%20studio%20background%2C%20professional%20editorial%20composition%2C%20high%20detail%2C%20moody%20atmospheric%2C%20consistent%20poster%20series%20style&width=600&height=900&seq=poster-t08&orientation=portrait",
    year: 2024,
    region: "日本",
    director: "佐藤悠真",
    cast: ["中村蓮", "小林澪", "山田匠"],
    genres: ["科幻", "冒险", "剧情"],
    tags: ["动画", "奇幻", "中文字幕"],
    summary:
      "一列驶向银河尽头的列车，载着各怀心事的乘客。浪漫瑰丽，充满想象力。",
    subtitleInfo: "日语原声配中文繁体/简体字幕已更新至第 6 集。",
    views: 189700,
    updatedAt: "2025-09-30",
    rating: 8.4,
    episodes: [
      { episode: 1, title: "启程", desc: "少年登上一列只在传说中出现的银河列车。" },
      { episode: 2, title: "星河站台", desc: "列车停靠在一座漂浮于星海的站台。" },
      { episode: 3, title: "失物招领", desc: "乘客们各自遗失的东西在车上被找回。" },
      { episode: 4, title: "光的尽头", desc: "列车驶向一片正在熄灭的星云。" },
      { episode: 5, title: "旧日旅客", desc: "一位特殊的旅客说出了列车的秘密。" },
      { episode: 6, title: "银河终点", desc: "终点站之外，是另一段旅程的起点。" },
    ],
  },
];